import styles from './index.module.scss';

export function CustomTypography({ children }) {
  return (
    <h1 className={styles.customTypography}>{children}</h1>
  );
}